import { Info } from "lucide-react";

import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from "@/components/ui/drawer";
import { Button } from "@/components/ui/button";

type FieldInfoButtonProps = {
  title: string;
  body: string;
};

export function FieldInfoButton({ title, body }: FieldInfoButtonProps) {
  return (
    <Drawer>
      <DrawerTrigger asChild>
        <button
          type="button"
          aria-label={`Help: ${title}`}
          className="inline-flex shrink-0 items-center justify-center rounded-full p-1 text-muted-foreground transition-colors hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          <Info size={16} aria-hidden="true" />
        </button>
      </DrawerTrigger>
      <DrawerContent>
        <DrawerHeader>
          <DrawerTitle className="text-left text-base">{title}</DrawerTitle>
          <DrawerDescription className="sr-only">
            Help for {title}
          </DrawerDescription>
        </DrawerHeader>
        <div className="px-4 pb-2">
          <p className="whitespace-pre-line text-sm leading-relaxed text-foreground">
            {body}
          </p>
        </div>
        <div className="p-4 pt-2">
          <DrawerClose asChild>
            <Button variant="outline" className="w-full">
              Close
            </Button>
          </DrawerClose>
        </div>
      </DrawerContent>
    </Drawer>
  );
}
